var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import * as cx from 'classnames';
import { MEDIA_QUERIES } from 'shared/style';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    max-width: 1200px;\n  }\n  ", " {\n    width: 100%;\n  }\n  height: 70px;\n  text-align: center;\n\n  > .list {\n    width: 100%;\n    height: 100%;\n    background-color: #f6f6f6;\n\n    > li {\n      font-size: 18px;\n      height: 70px;\n      line-height: 70px;\n      float: left;\n\n      ", " {\n        width: calc(100% / 13);\n      }\n\n      ", " {\n        width: calc(100% / 9);\n      }\n      \n      ", " {\n        width: calc(100% / 5);\n      }\n    }\n\n    > .current-page {\n      background-color: #36c;\n      color: #fff;\n    }\n\n    > .real-button {\n      cursor: pointer;\n\n      :hover {\n        background-color: #eee;\n        color: #000;\n      }\n    }\n\n    > .other-button {\n      font-size: 16px;\n    }\n\n    > .pc-only {\n      ", " {\n        display: list-item;\n      }\n  \n      ", " {\n        display: none;\n      }\n\n      ", " {\n        display: none;\n      }\n    }\n\n    > .upper-tablet-only {\n      ", " {\n        display: list-item;\n      }\n  \n      ", " {\n        display: list-item;\n      }\n\n      ", " {\n        display: none;\n      }\n    }\n  }\n"], ["\n  ", " {\n    max-width: 1200px;\n  }\n  ", " {\n    width: 100%;\n  }\n  height: 70px;\n  text-align: center;\n\n  > .list {\n    width: 100%;\n    height: 100%;\n    background-color: #f6f6f6;\n\n    > li {\n      font-size: 18px;\n      height: 70px;\n      line-height: 70px;\n      float: left;\n\n      ", " {\n        width: calc(100% / 13);\n      }\n\n      ", " {\n        width: calc(100% / 9);\n      }\n      \n      ", " {\n        width: calc(100% / 5);\n      }\n    }\n\n    > .current-page {\n      background-color: #36c;\n      color: #fff;\n    }\n\n    > .real-button {\n      cursor: pointer;\n\n      :hover {\n        background-color: #eee;\n        color: #000;\n      }\n    }\n\n    > .other-button {\n      font-size: 16px;\n    }\n\n    > .pc-only {\n      ", " {\n        display: list-item;\n      }\n  \n      ", " {\n        display: none;\n      }\n\n      ", " {\n        display: none;\n      }\n    }\n\n    > .upper-tablet-only {\n      ", " {\n        display: list-item;\n      }\n  \n      ", " {\n        display: list-item;\n      }\n\n      ", " {\n        display: none;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC, MEDIA_QUERIES.TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC, MEDIA_QUERIES.TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC, MEDIA_QUERIES.TABLET, MEDIA_QUERIES.PHONE);
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updatePage = function (page, e) {
            var _a = _this.props, totalPostCount = _a.totalPostCount, unit = _a.unit;
            e && e.preventDefault();
            var pageCount = Math.ceil(totalPostCount / unit);
            if (page && page > 0 && page <= pageCount) {
                _this.props.updatePage(page);
            }
        };
        return _this;
    }
    Pagination.prototype.renderPageList = function () {
        var _this = this;
        var _a = this.props, totalPostCount = _a.totalPostCount, currentPage = _a.currentPage, unit = _a.unit;
        var pageCount = Math.ceil(totalPostCount / unit);
        var pages = [];
        for (var i = -4; i <= 4; i += 1) {
            var page = currentPage + i;
            if (i < 0) {
                pages.push(page > 0 ? page : null);
            }
            else if (i > 0) {
                pages.push(page <= pageCount ? page : null);
            }
            else if (i === 0) {
                pages.push(currentPage);
            }
        }
        return pages.map(function (page, idx) {
            var pcOnly = idx <= 1 || idx >= 7;
            var upperTabletOnly = idx <= 3 || idx >= 5;
            var current = idx === 4;
            return (React.createElement("li", { key: idx, className: cx({
                    'pc-only': pcOnly,
                    'upper-tablet-only': upperTabletOnly,
                    'current-page': current,
                    'real-button': page,
                }), onClick: function (e) { return _this.updatePage(page, e); } }, page || ''));
        });
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var _a = this.props, totalPostCount = _a.totalPostCount, currentPage = _a.currentPage, unit = _a.unit;
        var pageCount = Math.ceil(totalPostCount / unit);
        return pageCount > 1 ? (React.createElement(RootDiv, null,
            React.createElement("ul", { className: "list" },
                React.createElement("li", { className: "other-button real-button", onClick: function (e) { return _this.updatePage(1, e); } }, "\uCC98\uC74C"),
                React.createElement("li", { className: "other-button real-button", onClick: function (e) { return _this.updatePage(currentPage - 1, e); } }, "<"),
                this.renderPageList(),
                React.createElement("li", { className: "other-button real-button", onClick: function (e) { return _this.updatePage(currentPage + 1, e); } }, ">"),
                React.createElement("li", { className: "other-button real-button", onClick: function (e) { return _this.updatePage(pageCount, e); } }, "\uB05D")))) : null;
    };
    return Pagination;
}(React.Component));
export default Pagination;
var templateObject_1;
